export default __webpack_public_path__ + "static/media/pending-reviews_ico.6158002a.svg";